/* eslint-disable */

import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/nt",
      redirect: "/overview",
    },
    {
      path: "/sensordashboard",
      name: "SensorDashboard",
      component: () => import("./views/components/Page/SensorDashboard.vue"),
      props: true,
    },
    {
      path: "/sensorpage",
      name: "SensorPage",
      component: () => import("./views/components/Page/Subpage/SensorPage.vue"),
      props: true,
    },
    {
      path: "/sensoralert",
      name: "SensorAlert",
      component: () =>
        import("./views/components/Page/Subpage/SensorAlert.vue"),
      props: true,
    },
    {
      path: "/overview",
      name: "Overview",
      component: () => import("./views/components/Page/Overview.vue"),
    },
    {
      path: "/action",
      name: "Action",
      component: () => import("./views/components/Page/Action.vue"),
    },
    {
      path: "/actionlist",
      name: "ActionList",
      component: () =>
        import("./views/components/dashboard/Alert/ActionList.vue"),
      props: true,
    },
    {
      path: "/createaction",
      name: "CreateAction",
      component: () =>
        import("./views/components/Page/Subpage/CreateAction.vue"),
    },
    {
      path: "/map",
      name: "Map",
      component: () => import("./views/components/Page/Map.vue"),
    }, {
      path: "/map-sensor",
      name: "Mapsensor",
      component: () => import("./views/components/Page/Map_backup.vue"),
    },
    {
      path: "/overviewstate",
      name: "OverviewState",
      component: () =>
        import("./views/components/dashboard/Overview/OverviewState.vue"),
    },
    {
      path: "/network",
      name: "Network",
      component: () => import("./views/components/Page/Network.vue"),
    },
    {
      path: "/networklist",
      name: "NetworkList",
      component: () =>
        import("./views/components/dashboard/Network/NetworkList.vue"),
    },
    {
      path: "/viewnetwork",
      name: "ViewNetwork",
      component: () =>
        import("./views/components/Page/Subpage/ViewNetwork.vue"),
      props: true,
    },
    {
      path: "/createnetwork",
      name: "CreateNetwork",
      component: () =>
        import("./views/components/Page/Subpage/CreateNetwork.vue"),
    },
    {
      path: "/adddevice",
      name: "AddDevice",
      component: () => import("./views/components/Page/Subpage/AddDevice.vue"),
      props: true,
    },
    {
      path: "/editnetwork",
      name: "EditNetwork",
      component: () =>
        import("./views/components/Page/Subpage/EditNetwork.vue"),
    },
    {
      path: "/state",
      name: "State",
      component: () => import("./views/components/dashboard/Sensor/State.vue"),
      props: true,
    },
    {
      path: "/alertstate",
      name: "AlertState",
      component: () =>
        import("./views/components/dashboard/Sensor/AlertState.vue"),
      props: true,
    },
    {
      path: "/addgateway",
      name: "AddGateway",
      component: () => import("./views/components/Page/Subpage/AddGateway.vue"),
      props: true,
    },
    {
      path: "/activestate",
      name: "ActiveState",
      component: () =>
        import("./views/components/dashboard/Overview/ActiveState.vue"),
      props: true,
    },
    {
      path: "/shownetwork",
      name: "ShowNetwork",
      component: () =>
        import("./views/components/dashboard/Overview/ShowNetwork.vue"),
      props: true,
    },
    {
      path: "/lastsensorstate",
      name: "LastSensorState",
      component: () =>
        import("./views/components/dashboard/Overview/LastSensorState.vue"),
      props: true,
    },
    {
      path: "/alertlist",
      name: "alertlist",
      component: () =>
        import("./views/components/dashboard/Overview/AlertList.vue"),
      props: true,
    },
    {
      path: "/register",
      name: "Register",
      component: () => import("./views/components/Page/Register.vue"),
      props: true,
    },
    {
      path: "/sensor",
      name: "Sensor",
      component: () => import("./views/components/Page/Sensor.vue"),
      props: true,
    },
    {
      path: "/gateway",
      name: "Gateway",
      component: () => import("./views/components/Page/Gateway.vue"),
      props: true,
    },
    {
      path: "/report",
      name: "Report",
      component: () => import("./views/components/Page/Report.vue"),
      props: true,
    },
    {
      path: "/location",
      name: "Location",
      component: () => import("./views/components/Page/Location.vue"),
      props: true,
    },
    {
      path: "/locationsetting",
      name: "LocationSetting",
      component: () => import("./views/components/Page/LocationSetting.vue"),
      props: true,
    },
    {
      path: "/camera",
      name: "Camera",
      component: () => import("./views/components/Page/Camera.vue"),
      props: true,
    },
    {
      path: "/user",
      name: "User",
      component: () => import("./views/components/Page/User.vue"),
      props: true,
    },
    {
      path: "/permissionsetting",
      name: "PermissionSetting",
      component: () =>
        import("./views/components/Page/Subpage/PermissionSetting.vue"),
      props: true,
    },
    {
      path: "/setting",
      name: "Setting",
      component: () => import("./views/components/Page/Setting.vue"),
      props: true,
    },
    {
      path: "/controls",
      name: "Control",
      component: () =>
        import("./views/components/dashboard/Sensor/Control.vue"),
      props: true,
    },
    {
      path: "/historylog",
      name: "HistoryLog",
      component: () => import("./views/components/Page/HistoryLog.vue"),
      props: true,
    },
    {
      path: "/form",
      name: "Form",
      component: () => import("./views/components/Page/Form.vue"),
      props: true,
    },
    {
      path: "/workorder",
      name: "WorkOrder",
      component: () => import("./views/components/Page/WorkOrder.vue"),
      props: true,
    },
    {
      path: "/workstatus",
      name: "WorkStatus",
      component: () => import("./views/components/Page/WorkStatus.vue"),
      props: true,
    },
    {
      path: "/permission",
      name: "Permission",
      component: () => import("./views/components/Page/Permission.vue"),
      props: true,
    },
    {
      path: "/Test",
      name: "Test",
      component: () => import("./views/components/Page/Test.vue"),
    },
    {
      path: "/Test2",
      name: "Test2",
      component: () => import("./views/components/Page/Test2.vue"),
    },
    {
      path: "/Test4",
      name: "Test4",
      component: () => import("./views/components/Page/Test4.vue"),
    },
    {
      path: "/WorkTemplate",
      name: "WorkTemplate",
      component: () => import("./views/components/Page/WorkTemplate.vue"),
    },
    {
      path: "/App",
      name: "App",
      component: () => import("./App.vue"),
    },
    {
      path: "/Alert",
      name: "Alert",
      component: () => import("./views/components/Page/Alert.vue"),
    },
    {
      path: "/ViewAlert",
      name: "ViewAlert",
      component: () => import("./views/components/Page/Subpage/ViewAlert.vue"),
    },
    {
      path: "/ViewAlert/:idalert",
      name: "ViewAlert",
      component: () => import("./views/components/Page/Subpage/ViewAlert.vue"),
    },
    {
      path: "/Test6",
      name: "Test6",
      component: () => import("./views/components/Page/Test6.vue"),
    },
    {
      path: "/login2",
      name: "Login2",
      component: () => import("./views/components/Page/login2.vue"),
      props: true,
      meta: {
        layout: "blank",
        resource: "Public",
      },
    },
    {
      path: "/ViewGateway",
      name: "ViewGateway",
      component: () =>
        import("./views/components/Page/Subpage/ViewGateway.vue"),
      props: true,
    },
    {
      path: "/WorkRequests",
      name: "WorkRequests",
      component: () => import("./views/components/Page/WorkRequests.vue"),
      props: true,
    },
    {
      path: "/indoortracking",
      name: "Indoortracking",
      component: () => import("./views/components/Page/indoortracking.vue"),
      props: true,
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: () =>
        import("./views/components/dashboard/Enco/Dashboard.vue"),
      props: true,
    },
    {
      path: "/setupWorkRequests",
      name: "setupWorkRequests",
      component: () =>
        import(
          "./views/components/dashboard/WorkRequest/SetupWorkRequests.vue"
        ),
      props: true,
    },
    {
      path: "/printTemplate",
      name: "printTemplate",
      component: () =>
        import(
          "./views/components/dashboard/Workorder/btnBulkaction/printTemplate.vue"
        ),
    },
    {
      path: "/IndoorSensor",
      name: "IndoorSensor",
      component: () =>
        import("./views/components/Page/IndoorTracking/IndoorSensor.vue"),
    },
    {
      path: "/IndoorAlert",
      name: "IndoorAlert",
      component: () =>
        import("./views/components/Page/IndoorTracking/IndoorAlert.vue"),
    },
    {
      path: "/IndoorAlertSetting",
      name: "IndoorAlertSetting",
      component: () =>
        import("./views/components/Page/IndoorTracking/IndoorAlertSetting.vue"),
    },
    {
      path: "/IndoorGateway",
      name: "IndoorGateway",
      component: () =>
        import("./views/components/Page/IndoorTracking/IndoorGateway.vue"),
    },
    {
      path: "/IndoorSensorDashboard",
      name: "IndoorSensorDashboard",
      component: () =>
        import(
          "./views/components/Page/IndoorTracking/IndoorSensorDashboard.vue"
        ),
    },
    {
      path: "/IndoorOverview",
      name: "OverviewIndoor",
      component: () =>
        import("./views/components/Page/IndoorTracking/OverviewIndoor.vue"),
    },
    {
      path: "/IndoorReport",
      name: "ReportIndoor",
      component: () =>
        import("./views/components/Page/IndoorTracking/ReportIndoor.vue"),
    },
    {
      path: "/IndoorDashboard",
      name: "DashboardIndoor",
      component: () =>
        import("./views/components/Page/IndoorTracking/IndoorDashboard.vue"),
    },
    {
      path: "/IndoorEsset",
      name: "EssetIndoor",
      component: () =>
        import("./views/components/Page/IndoorTracking/Esset.vue"),
    },
    {
      path: "/IndoorTag",
      name: "TagIndoor",
      component: () => import("./views/components/Page/IndoorTracking/Tag.vue"),
    },
    {
      path: "/RFIDTag",
      name: "RFIDTag",
      component: () => import("./views/components/Page/RFID/Tag.vue"),
    },
    {
      path: "/DashboardRFIDTag",
      name: "DashboardRFIDTag",
      component: () => import("./views/components/Page/RFID/DashboardTag.vue"),
    },
    {
      path: "/ViewGatewayIndoor",
      name: "ViewGatewayIndoor",
      component: () =>
        import("./views/components/Page/Subpage/ViewGatewayIndoor.vue"),
      props: true,
    },
    {
      path: "/sensordashboardIndoor",
      name: "SensorDashboardIndoor",
      component: () =>
        import("./views/components/Page/SensorDashboardIndoor.vue"),
      props: true,
    },
    {
      path: "/editTag",
      name: "editTag",
      component: () => import("./views/components/Page/Subpage/editTag.vue"),
      props: true,
    },
    {
      path: "/IndoorReportTag",
      name: "IndoorReportTag",
      component: () =>
        import("./views/components/Page/IndoorTracking/IndoorReportTag.vue"),
    },
    {
      path: "/IndoorRealtimeWorker",
      name: "IndoorRealtimeWorker",
      component: () =>
        import(
          "./views/components/Page/IndoorTracking/IndoorRealtimeWorker.vue"
        ),
    },
    {
      path: "/mailbox",
      name: "Mailbox",
      component: () => import("./views/components/Page/Mailbox/Mailbox.vue"),
    },
    {
      path: "/mailboxdashboard",
      name: "MailboxDashboard",
      component: () =>
        import("./views/components/Page/Mailbox/MailboxDashboard.vue"),
    },
    {
      path: "/ViewAlert?alertid=:alertId&historyid=:historyId",
      name: "ViewAlert",
      component: () => import("./views/components/Page/Subpage/ViewAlert.vue"),
    },
    {
      path: "/reportproblem",
      name: "reportproblem",
      component: () =>
        import("./views/components/dashboard/WorkRequest/ReportProblem.vue"),
    },
    {
      path: "/parts",
      name: "parts",
      component: () => import("./views/components/Page/Parts.vue"),
    },

    {
      path: "/dashTest3",
      name: "dashTest3",
      component: () => import("./views/components/Page/dashTest3.vue"),
    },
    {
      path: "/request/:uuid",
      name: "Request",
      component: () => import("./views/components/Page/Request.vue"),
    },
    {
      path: "/assetdashboardIndoor",
      name: "AssetDashboardIndoor",
      component: () =>
        import("./views/components/Page/AssetDashboardIndoor.vue"),
      props: true,
    },
    {
      path: "/sensordashboardIndoor2",
      name: "SensorDashboardIndoor2",
      component: () =>
        import("./views/components/Page/SensorDashboardIndoor2.vue"),
      props: true,
    },
    {
      path: "/createactionindoor",
      name: "CreateActionIndoor",
      component: () =>
        import("./views/components/Page/Subpage/CreateActionIndoor.vue"),
    },

    // dashboard sriboonrueng
    {
      path: "/dashboard/sriboonrueng",
      name: "sriboonrueng",
      component: () =>
        import("./views/components/Page/SriboonruengDashboard.vue"),
    },

    // dashboard rivacold
    {
      path: "/locationdashboard",
      name: "locationdashboard",
      component: () =>
        import("./views/components/dashboard/rivacold/location.vue"),
    },
    {
      path: "/MACdashboard",
      name: "MACdashboard",
      component: () =>
        import("./views/components/dashboard/rivacold/dashboard.vue"),
    },

    // dashboard Fraser
    {
      path: "/customdashboard",
      name: "customdashboard",
      component: () =>
        import("./views/components/dashboard/Fraser/CustomDashboard.vue"),
    },
    {
      path: "/customdashboardRojana",
      name: "customdashboardRojana",
      component: () =>
        import("./views/components/dashboard/Fraser/CustomDashboardRojana.vue"),
    },
    {
      path: "/customdashboardJasperW1",
      name: "customdashboardJasperW1",
      component: () =>
        import("./views/components/dashboard/Fraser/customdashboardJasperW1.vue"),
    },
    {
      path: "/customdashboardJasperW3",
      name: "customdashboardJasper",
      component: () =>
        import("./views/components/dashboard/Fraser/customdashboardJasper.vue"),
    },
    {
      path: "/customdashboardBangplee",
      name: "customdashboardBangplee",
      component: () =>
        import("./views/components/dashboard/Fraser/customdashboardBangplee.vue"),
    },
    {
      path: "/customdashboardYellowW3",
      name: "customdashboardYellowW3",
      component: () =>
        import("./views/components/dashboard/Fraser/CustomDashboardYW3.vue"),
    },
    {
      path: "/customdashboardgarnett",
      name: "customdashboardgarnett",
      component: () =>
        import("./views/components/dashboard/Fraser/CustomDashboardGarnett.vue"),
    },
    {
      path: "/graph",
      name: "graph",
      component: () =>
        import("./views/components/dashboard/Fraser/graphVisualization.vue"),
    },
    {
      path: "/mapOverview",
      name: "mapOverview",
      component: () =>
        import("./views/components/dashboard/Fraser/mapfordash.vue"),
    },

    // dashboard kubota
    {
      path: "/kubotafarm",
      name: "kubotafarm",
      component: () =>
        import("./views/components/dashboard/kubota/dashboard.vue"),
    },
    {
      path: "/riceplan",
      name: "riceplan",
      component: () =>
        import("./views/components/dashboard/kubota/rice_plant.vue"),
    },
    {
      path: "/solarplan",
      name: "solarplan",
      component: () =>
        import("./views/components/dashboard/kubota/solar_plant.vue"),
    },
    {
      path: "/plant3",
      name: "plant3",
      component: () => import("./views/components/dashboard/kubota/plant3.vue"),
    },
    {
      path: "/plant4",
      name: "plant4",
      component: () => import("./views/components/dashboard/kubota/plant4.vue"),
    },
    {
      path: "/plant5",
      name: "plant5",
      component: () => import("./views/components/dashboard/kubota/plant5.vue"),
    },
    {
      path: "/plant6",
      name: "plant6",
      component: () => import("./views/components/dashboard/kubota/plant6.vue"),
    },
    {
      path: "/plant7",
      name: "plant7",
      component: () => import("./views/components/dashboard/kubota/plant7.vue"),
    },
    {
      path: "/plant8",
      name: "plant8",
      component: () => import("./views/components/dashboard/kubota/plant8.vue"),
    },
    // dashboard kubota public
    {
      path: "/kubotafarmOverview",
      name: "kubotafarmOverview",
      component: () =>
        import("./views/components/dashboard/kubota/dashboard/page1.vue"),
      meta: {
        layout: "kubota",
        resource: "Public",
      },
    },
    {
      path: "/kubotafarmSolar",
      name: "kubotafarmSolar",
      component: () =>
        import(
          "./views/components/dashboard/kubota/dashboard/respage_solar.vue"
        ),
      meta: {
        layout: "kubota",
        resource: "Public",
      },
    },
    {
      path: "/kubotafarmRice",
      name: "kubotafarmRice",
      component: () =>
        import(
          "./views/components/dashboard/kubota/dashboard/respage_rice.vue"
        ),
      meta: {
        layout: "kubota",
        resource: "Public",
      },
    },
    {
      path: "/kubotafarmPlant3",
      name: "kubotafarmPlant3",
      component: () =>
        import(
          "./views/components/dashboard/kubota/dashboard/respage_plant3.vue"
        ),
      meta: {
        layout: "kubota",
        resource: "Public",
      },
    },
    {
      path: "/kubotafarmPlant4",
      name: "kubotafarmPlant4",
      component: () =>
        import(
          "./views/components/dashboard/kubota/dashboard/respage_plant4.vue"
        ),
      meta: {
        layout: "kubota",
        resource: "Public",
      },
    },
    {
      path: "/kubotafarmPlant5",
      name: "kubotafarmPlant5",
      component: () =>
        import(
          "./views/components/dashboard/kubota/dashboard/respage_plant5.vue"
        ),
      meta: {
        layout: "kubota",
        resource: "Public",
      },
    },
    {
      path: "/kubotafarmPlant6",
      name: "kubotafarmPlant6",
      component: () =>
        import(
          "./views/components/dashboard/kubota/dashboard/respage_plant6.vue"
        ),
      meta: {
        layout: "kubota",
        resource: "Public",
      },
    },
    {
      path: "/kubotafarmPlant7",
      name: "kubotafarmPlant7",
      component: () =>
        import(
          "./views/components/dashboard/kubota/dashboard/respage_plant7.vue"
        ),
      meta: {
        layout: "kubota",
        resource: "Public",
      },
    },
    {
      path: "/kubotafarmPlant8",
      name: "kubotafarmPlant8",
      component: () =>
        import(
          "./views/components/dashboard/kubota/dashboard/respage_plant8.vue"
        ),
      meta: {
        layout: "kubota",
        resource: "Public",
      },
    },

    // dashboard Enco
    {
      path: "/departmentA",
      name: "departmentA",
      component: () =>
        import("./views/components/dashboard/Enco/departmentA.vue"),
    },

    {
      path: "/departmentA-public",
      name: "departmentA-public",
      component: () =>
        import("./views/components/dashboard/Enco/departmentA.vue"),
      meta: {
        layout: "blank",
        resource: "Public",
      },
    },
    {
      path: "/departmentB",
      name: "departmentB",
      component: () =>
        import("./views/components/dashboard/Enco/departmentB.vue"),
    },
    {
      path: "/departmentB-public",
      name: "departmentB-public",
      component: () =>
        import("./views/components/dashboard/Enco/departmentB.vue"),
      meta: {
        layout: "blank",
        resource: "Public",
      },
    },

    // dashboard yamaha
    {
      path: "/yamaha/alert",
      name: "yamaha/alert",
      component: () =>
        import("./views/components/dashboard/Overview/Yamaha/Alert.vue"),
    },
    {
      path: "/yamaha/overview",
      name: "yamaha/overview",
      component: () =>
        import("./views/components/dashboard/Overview/Yamaha/Overview.vue"),
    },
    {
      path: "/mbrplant",
      name: "mbrplant",
      component: () =>
        import("./views/components/dashboard/yamaha/mbr_plant.vue"),
    },
    {
      path: "/roplant",
      name: "roplant",
      component: () =>
        import("./views/components/dashboard/yamaha/ro_plant.vue"),
    },
    {
      path: "/centerplant",
      name: "centerplant",
      component: () =>
        import("./views/components/dashboard/yamaha/center_plant.vue"),
    },
    {
      path: "/dafplant",
      name: "dafplant",
      component: () =>
        import("./views/components/dashboard/yamaha/daf_plant.vue"),
    },
    {
      path: "/AluminiumPaintingWWTPplant",
      name: "AluminiumPaintingWWTPplant",
      component: () =>
        import("./views/components/dashboard/yamaha/aluminium_plant.vue"),
    },
    {
      path: "/PlasticPaintingWWTPplant",
      name: "PlasticPaintingWWTPplant",
      component: () =>
        import("./views/components/dashboard/yamaha/plastic_plant.vue"),
    },
    {
      path: "/dataExport",
      name: "dataExport",
      component: () => import("./views/components/dashboard/yamaha/report.vue"),
    },
    {
      path: "/mapdashboard",
      name: "mapdashboard",
      component: () => import("./views/components/dashboard/yamaha/map.vue"),
    },
    {
      path: "/recycleplant",
      name: "recycleplant",
      component: () =>
        import("./views/components/dashboard/yamaha/recycle_plant.vue"),
    },
    {
      path: "/asplant",
      name: "asplant",
      component: () =>
        import("./views/components/dashboard/yamaha/as_plant.vue"),
    },

    // dashboard yamaha aqi
    // {
    //   path: "/aqidashboard",
    //   name: "aqidashboard",
    //   component: () =>
    //     import("./views/components/dashboard/yamahaaqi/dashboard.vue"),
    // },
    {
      path: "/aqidashboard",
      name: "aqidashboard",
      component: () =>
        import("./views/components/dashboard/yamahaaqi/olddash.vue"),
    },
    {
      path: "/aqidashboardgraph",
      name: "aqidashboardgraph",
      component: () =>
        import("./views/components/dashboard/yamahaaqi/displaygraph.vue"),
    },
    // dashboard I-APC
    {
      path: "/I-APC",
      name: "I-APC",
      component: () =>
        import("./views/components/dashboard/I-APC/dashboard.vue"),
    },
    {
      path: "/I-APC-RM",
      name: "I-APC-RM",
      component: () =>
        import("./views/components/dashboard/I-APC/ResourseManage.vue"),
    },
    {
      path: "/I-APC-RM-view-all",
      name: "I-APC-RM-view-all",
      component: () =>
        import("./views/components/dashboard/I-APC/RMViewAll.vue"),
    },
    {
      path: "/I-APC-Floor/:index",
      name: "I-APC-Floor",
      component: () =>
        import("./views/components/dashboard/I-APC/FloorManagement.vue"),
    },

    // dashboard syntec
    {
      path: "/dashboardIndoor",
      name: "dashboardIndoor",
      component: () =>
        import("./views/components/dashboard/syntec/dashboard.vue"),
    },

    // dashboard Unicorn
    {
      path: "/Stock-DashBoard",
      name: "StockDashBoard",
      component: () =>
        import("./views/components/dashboard/Unicorn/StockDashBoard.vue"),
    },
    {
      path: "/StockAlert",
      name: "StockAlert",
      component: () =>
        import("./views/components/dashboard/Overview/Unicorn/StockAlert.vue"),
    },

    // dashboard KPCool
    {
      path: "/KPCool",
      name: "KPCool",
      component: () =>
        import("./views/components/dashboard/KPCool/dashboard.vue"),
    },

    // dashboard v-steel
    {
      path: "/v-steel/:place",
      name: "v-steel",
      component: () =>
        import("./views/components/dashboard/V-Steel/DashBoard.vue"),
    },
    // {
    //     path: "/v-steel-gif-off",
    //     name: "v-steel-gif-off",
    //     index: 110,
    //     component: () =>
    //         import (
    //             "./views/components/dashboard/V-Steel/DashBoard_gif_off.vue"
    //         ),
    // },

    // dashboard Hino
    {
      path: "/hino/report-data",
      component: () =>
        import("./views/components/dashboard/Hino/report/reportData.vue"),
    },
    {
      path: "/bodyOutLine/:id",
      name: "bodyOutLine",
      component: () =>
        import("./views/components/dashboard/Hino/Dashboard/Destiation.vue"),
    },
    {
      path: "/EngineAssemblyLine",
      name: "EngineAssemblyLine",
      component: () =>
        import(
          "./views/components/dashboard/Hino/Dashboard/EngineAssemblyLine.vue"
        ),
    },
    {
      path: "/BodyOutLine",
      name: "BodyOutLine",
      component: () =>
        import("./views/components/dashboard/Hino/Dashboard/BodyOutLine.vue"),
    },
    {
      path: "/ConeveyerLine",
      name: "ConeveyerLine",
      component: () =>
        import(
          "./views/components/dashboard/Hino/Dashboard/EngineAssemblyLine.vue"
          // "./views/components/dashboard/Hino/Dashboard/ConeveyerLine.vue"
        ),
    },

    // dashboard CPF
    {
      path: "/cpf/machine",
      name: "Machine",
      component: () =>
        import("./views/components/dashboard/CPF/ListMachine.vue"),
    },
    {
      path: "/cpf/machine/:id",
      name: "MachineMAc",
      component: () =>
        import("./views/components/dashboard/CPF/DashboardMachine.vue"),
    },

    // dashboard NikhomLatKrabang
    {
      path: "/Station10",
      name: "Station10",
      component: () =>
        import("./views/components/dashboard/NikhomLatKrabang/Station10.vue"),
    },
    {
      path: "/Station03",
      name: "Station03",
      component: () =>
        import("./views/components/dashboard/NikhomLatKrabang/Station03.vue"),
    },
    {
      path: "/Station05",
      name: "Station05",
      component: () =>
        import("./views/components/dashboard/NikhomLatKrabang/Station05.vue"),
    },
    {
      path: "/Station06",
      name: "Station06",
      component: () =>
        import("./views/components/dashboard/NikhomLatKrabang/Station06.vue"),
    },
    {
      path: "/Station07",
      name: "Station07",
      component: () =>
        import("./views/components/dashboard/NikhomLatKrabang/Station07.vue"),
    },
    {
      path: "/Station09",
      name: "Station09",
      component: () =>
        import("./views/components/dashboard/NikhomLatKrabang/Station09.vue"),
    },
    {
      path: "/FPSDashboardOverview",
      name: "FPSDashboardOverview",
      component: () =>
        import(
          "./views/components/dashboard/NikhomLatKrabang/DashboardOverview.vue"
        ),
    },

    // dashboard warehouse
    {
      path: "/warehouse",
      component: () =>
        import("./views/components/dashboard/Warehouse/Dashboard.vue"),
    },
    {
      path: "/office-dashboard",
      name: "officedashboard",
      component: () =>
        import("./views/components/dashboard/Warehouse/OfficeDashboard.vue"),
    },

    {
      path: "/cameratest",
      name: "cameratest",
      component: () => import("./views/components/Page/cameratest.vue"),
    },

    // dashboard hotel
    {
      path: "/hotel/dashboard/:building",
      name: "hotel/dashboard",
      component: () =>
        import("./views/components/dashboard/Hotel/Dashboard.vue"),
    },

    // dashboard RFID
    {
      path: "/RFID/dashboard",
      name: "RFID/dashboard",
      component: () =>
        import("./views/components/dashboard/RFID/Dashboard.vue"),
    },

    // dashboard D-net
    {
      path: "/dnetlocationdashboard",
      name: "d-net-locationdashboard",
      component: () =>
        import("./views/components/dashboard/D-net/location.vue"),
    },
    {
      path: "/dnetdashboard",
      name: "dnetdashboard",
      component: () =>
        import("./views/components/dashboard/D-net/dashboard.vue"),
    },

    {
      path: "/3dtest",
      name: "3dtest",
      component: () => import("./views/components/Page/3DTestPage.vue"),
    },
    {
      path: "/unitytest",
      name: "unitytest",
      component: () => import("./views/components/Page/UnityTestPage.vue"),
    },
    {
      path: "/vrtest",
      name: "vrtest",
      component: () => import("./views/components/Page/VRTestPage.vue"),
    },

    {
      path: "/thingsboard",
      name: "thingsboard",
      component: () => import("./views/components/Page/thingsboard.vue"),
    },

    {
      path: "/smarthome",
      name: "Smarthome",
      component: () => import("./views/components/Page/Smarthome.vue"),
    },
    {
      path: "/pmFullPage",
      name: "pmFullPage",
      component: () => import("./views/components/dashboard/PM/pmFullPage.vue"),
    },
    {
      path: "/Barcode",
      name: "Barcode",
      component: () => import("./views/components/Page/Barcode.vue"),
    },
    {
      path: "/Crop",
      name: "Crop",
      component: () => import("./views/components/Page/Crop.vue"),
    },
    {
      path: "/testupload",
      name: "Upload",
      component: () => import("./views/components/Page/Test_Upload.vue"),
    },
    {
      path: "/high-chart",
      name: "high-chart",
      component: () => import("./views/components/material/StockHighChart.vue"),
    },

    {
      path: "/login",
      name: "Login",
      component: () =>
        import("./views/view-componentsSentenance/Login/LoginPage.vue"),
      props: true,
      meta: {
        layout: "blank",
        resource: "Public",
      },
    },
    {
      path: "/Resetpassword",
      name: "Resetpassword",
      component: () =>
        import("./views/view-componentsSentenance/Login/LoginPage.vue"),
      props: true,
      meta: {
        layout: "blank",
        resource: "Public",
      },
    },
    {
      path: "/vuetree",
      name: "VueTreeList",
      component: () => import("./TreeListMaster/VueTreeList1.vue"),
    },
    {
      path: "/location/manage",
      name: "NewLo",
      component: () => import("./views/components/NewLocation/index.vue"),
    },

    {
      path: "/tempdashboard",
      name: "tempdashboard",
      component: () =>
        import("./views/components/dashboard/tempdemo/dashboard.vue"),
    },
    {
      path: "/tempdashboard2",
      name: "tempdashboard2",
      component: () =>
        import("./views/components/dashboard/tempdemo/dashboard1.vue"),
    },
    {
      path: "/loginnew",
      name: "loginnew",
      component: () =>
        import("./views/components/dashboard/kubota/loginnew.vue"),
      meta: {
        layout: "blank",
        resource: "Public",
      },
    },
    {
      path: "/CustomerSatisfactionForm",
      name: "CustomerSatisfactionForm",
      component: () =>
        import("./views/components/Page/CustomerSatisfactionForm.vue"),
    },

    {
      path: "/dollhouse",
      name: "dollhouse",
      component: () => import("./views/components/Page/dollhouse.vue"),
    },
    {
      path: "/listmap",
      name: "listmap",
      component: () => import("./views/components/Page/map/listmap.vue"),
    },
    {
      path: "/plotmap",
      name: "plotmap",
      component: () => import("./views/components/Page/map/plotmap.vue"),
    },
    {
      path: "/pirsocket",
      name: "pirsocket",
      component: () => import("./views/components/Page/PIRtest.vue"),
    },
    // dashboard QCON
    {
      path: "/Factory/Machinelist/:building",
      name: "Machinelist",
      component: () =>
        import("./views/components/dashboard/QCON/Machinelist.vue"),
    },
    {
      path: "/Factory/Machinelist/:building/:machine",
      component: () =>
        import("./views/components/dashboard/QCON/dashboard/dashboard.vue"),
    },
    // dashboard Ajinomoto
    {
      path: "/Machinelist/:building",
      name: "Machinelist",
      component: () =>
        import("./views/components/dashboard/Ajinomoto/Machinelist.vue"),
    },
    {
      path: "/Machinelist/:building/:machine",
      component: () =>
        import(
          "./views/components/dashboard/Ajinomoto/dashboard/dashboard.vue"
        ),
    },
    {
      path: "/getlocation",
      component: () => import("./views/components/Page/test3.vue"),
    },
    {
      path: "/resource-dashboard",
      name: "ResourceDashboard",
      component: () =>
        import("./views/components/dashboard/unknow/ResourseDashboard.vue"),
    },
    {
      path: "/OverviewAjinomotoDashbooard",
      name: "OverviewAjinomotoDashbooard",
      component: () =>
        import("./views/components/dashboard/Ajinomoto/OverviewDashbooard.vue"),
    },
    {
      path: "/ajinomoto/report",
      component: () =>
        import("./views/components/dashboard/Ajinomoto/report.vue"),
    },
    {
      path: "/PublicAjinomoto/AjinomotoOverview",
      name: "AjinomotoOverview",
      component: () =>
        import("./views/components/dashboard/Ajinomoto/OverviewDashbooard.vue"),
      meta: {
        layout: "navbar",
        resource: "Public",
      },
    },
    {
      path: "/PublicAjinomoto/Machinelist/:building",
      component: () =>
        import("./views/components/dashboard/Ajinomoto/Machinelist.vue"),
      meta: {
        layout: "navbar",
        resource: "Public",
      },
    },
    {
      path: "/PublicAjinomoto/Machinelist/:building/:machine",
      component: () =>
        import(
          "./views/components/dashboard/Ajinomoto/dashboard/dashboard.vue"
        ),
      meta: {
        layout: "navbar",
        resource: "Public",
      },
    },
    // {
    //     path: "/Machinelist/:place",
    //     name: "Machinelist",
    //     component: () =>
    //         import ("./views/components/dashboard/Ajinomoto/Machinelist.vue"),
    // },
    //Officemate
    {
      path: "/officemate/I-Sentenance",
      name: "I-Sentenance",
      component: () =>
        import("./views/components/dashboard/officemate/I-Sentenance.vue"),
    },
    {
      path: "/officemate/peopleCounting",
      name: "peopleCounting",
      component: () =>
        import("./views/components/dashboard/officemate/peopleCounting.vue"),
    },
    //stockdemo

    {
      path: "/Stock/List",
      name: "List",
      component: () =>
        import("./views/components/dashboard/stockdemo/StockList.vue"),
    },
    {
      path: "/Stock/Dashboard/Warehouse",
      name: "Warehouse",
      component: () =>
        import("./views/components/dashboard/stockdemo/Warehouse.vue"),
    },
    {
      path: "/Stock/Dashboard/WarehouseLocation",
      name: "WarehouseLocation",
      component: () =>
        import("./views/components/dashboard/stockdemo/WarehouseLocation.vue"),
    },

    // map tracking
    {
      path: "/map-tracking",
      name: "map-tracking",
      component: () =>
        import("./views/components/dashboard/Map/MapTracking.vue"),
    },
    {
      path: "/map-test",
      name: "map-test",
      component: () => import("./views/components/dashboard/Map/MapTest.vue"),
    },

    // matterport
    {
      path: "/matterport",
      name: "matterport",
      component: () =>
        import("./views/components/dashboard/Matterport/testlibBundle.vue"),
    },

    // Inventory
    {
      path: "/inventory/location",
      name: "inventory-location",
      component: () =>
        import("./views/components/dashboard/Inventory/LocationList.vue"),
    },
    {
      path: "/inventory/info",
      name: "inventory-info",
      component: () =>
        import("./views/components/dashboard/Inventory/LocationInfo.vue"),
    },

    // xtple
    {
      path: "/xtple/dashboard",
      name: "xtple-dashboard",
      component: () =>
        import("./views/components/dashboard/xtple/Dashboard.vue"),
    },
    // LTC
    {
      path: "/LTC/dashboard/:id",
      name: "ltc-dashboard",
      component: () => import("./views/components/dashboard/LTC/Dashboard.vue"),
    },
    //sentenancedemo
    {
      path: "/demo/Energymonitoring/aqi",
      name: "aqi-energymonitoring-dashboard",
      component: () =>
        import("./views/components/dashboard/demosentenance/aqi.vue"),
    },
    {
      path: "/demo/smartfarm",
      name: "smartfarm-dashboard",
      component: () =>
        import("./views/components/dashboard/demosentenance/smartfarm.vue"),
    },
    {
      path: "/demo/Energymonitoring/OverviewDashbooard",
      name: "energymonitoring-Dashbooard",
      component: () =>
        import(
          "./views/components/dashboard/demosentenance/Energymonitoring/OverviewDashbooard.vue"
        ),
    },
    {
      path: "/demo/Energymonitoring/Machinelist/:building",
      name: "energymonitoring-Machinelist",
      component: () =>
        import(
          "./views/components/dashboard/demosentenance/Energymonitoring/Machinelist.vue"
        ),
    },
    {
      path: "/demo/Energymonitoring/Machinelist/:building/:machine",
      component: () =>
        import(
          "./views/components/dashboard/demosentenance/Energymonitoring/dashboard/dashboard.vue"
        ),
    },
    {
      path: "/demo/Energymonitoring/report",
      component: () =>
        import(
          "./views/components/dashboard/demosentenance/Energymonitoring/report.vue"
        ),
    },
    {
      path: "/demo/smartoffice",
      name: "smartoffice-dashboard",
      component: () =>
        import(
          "./views/components/dashboard/demosentenance/SmartOffice/dashboard.vue"
        ),
    },
    {
      path: "/demo/workforce",
      name: "workfoce-dashboard",
      component: () =>
        import(
          "./views/components/dashboard/demosentenance/Workfoce/ResourseManage.vue"
        ),
    },
    {
      path: "/demo/data-center",
      component: () =>
        import(
          "./views/components/dashboard/demosentenance/DataCenter/dashboard.vue"
        ),
    },

    // COE
    {
      path: "/coe/tvvertical",
      name: "COE-TVvertical",
      component: () =>
        import("./views/components/dashboard/COE/TVvertical.vue"),
      meta: {
        layout: "blank",
        resource: "Public",
      },
    },
    {
      path: "/coe/bigscreen",
      name: "COE-bigscreen",
      component: () => import("./views/components/dashboard/COE/bigscreen.vue"),
      meta: {
        layout: "blank",
        resource: "Public",
      },
    },

    //farmdemo
    {
      path: "/smartfarmdemo/dashboard",
      component: () =>
        import("./views/components/dashboard/smartfarmdemo/dashboard.vue"),
    },

    // mhesi
    {
      path: "/mhesi/dashboard",
      name: "mhesi-dashboard",
      component: () =>
        import("./views/components/dashboard/mhesi/dashboard.vue"),
      meta: {
        // layout: "blank",
        // resource: "Public",
      },
    },
    {
      path: "/mhesi/register",
      name: "mhesi-register",
      component: () =>
        import("./views/components/dashboard/mhesi/register.vue"),
      meta: {
        // layout: "blank",
        // resource: "Public",
      },
    },
    {
      path: "/mhesi/editprofile",
      name: "mhesi-editprofile",
      component: () =>
        import("./views/components/dashboard/mhesi/register.vue"),
      meta: {
        // layout: "blank",
        // resource: "Public",
      },
    },
    {
      path: "/mhesi/tag",
      name: "mhesi-tag",
      component: () =>
        import("./views/components/dashboard/mhesi/TagProfile.vue"),
      meta: {
        // layout: "blank",
        // resource: "Public",
      },
    },
    {
      path: "/mhesi/room/:name",
      name: "mhesi-room",
      component: () => import("./views/components/dashboard/mhesi/room.vue"),
      meta: {
        // layout: "blank",
        // resource: "Public",
      },
    },
    {
      path: "/mhesi/location",
      name: "mhesi-location",
      component: () =>
        import("./views/components/dashboard/mhesi/location.vue"),
      meta: {
        // layout: "blank",
        // resource: "Public",
      },
    },
    {
      path: "/reportyamahaaqi",
      component: () =>
        import("./views/components/dashboard/yamahaaqi/report.vue"),
    },
    // dashboard FraserConsumtion
    {
      path: "/Machinelist/:building",
      name: "Machinelist",
      component: () =>
        import("./views/components/dashboard/FraserConsumtion/Machinelist.vue"),
    },
    {
      path: "/Machinelist/:building/:machine",
      component: () =>
        import(
          "./views/components/dashboard/FraserConsumtion/dashboard/dashboard.vue"
        ),
    },
    {
      path: "/getlocation",
      component: () => import("./views/components/Page/test3.vue"),
    },
    {
      path: "/resource-dashboard",
      name: "ResourceDashboard",
      component: () =>
        import("./views/components/dashboard/unknow/ResourseDashboard.vue"),
    },
    {
      path: "/FraserPowerconsumption",
      name: "FraserPowerconsumption",
      component: () =>
        import(
          "./views/components/dashboard/FraserConsumtion/OverviewDashbooard.vue"
        ),
    },

    // Asset World
    {
      path: "/asset-world/overview",
      name: "AssetWorldOverview",
      component: () => import("./views/components/Page/Overview.vue"),
    },
    {
      path: "/asset-world/report",
      name: "AssetWorldReport",
      component: () =>
        import("./views/components/dashboard/Ajinomoto/report.vue"),
    },
    {
      path: "/asset-world/dashboard",
      name: "AssetWorldDashboard",
      component: () => import("./views/components/AssetWorld/CustomDashboard.vue")
    },
    // Public
    {
      path: "/yamahaaqi/public/dashboard",
      name: "YamahaaqiPublicDashboard",
      component: () => import("./views/components/dashboard/yamahaaqi/share-dashboard.vue"),
      meta: {
        layout: "blank",
        resource: "Public",
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  // console.log("Router.To", to);
  // if (to.path === '/yamahaaqi/public/dashboard') {
  //   Vue.prototype.$session.set("accessToken", '')
  // }
  
  // console.log(Vue.prototype.$session.get('token'))
  // Vue.prototype.$loading.close()
  //   if (
  //     to.name == "Overview" &&
  //     Vue.prototype.$session.get("token") == "tmY8gRUIj9YOLwN5"
  //   ) {
  //     Vue.prototype.$session.set("nwname", "All Network");
  //     Vue.prototype.$session.set("name", "Light Control Sensor");
  //     Vue.prototype.$session.set("nwid", "65");
  //     Vue.prototype.$session.set("sensorid", "000001");
  //     Vue.prototype.$session.set("gatewayid", "000001");
  //     Vue.prototype.$session.set("type", "control");
  //     next({
  //       name: "SensorDashboard",
  //       params: {
  //         nwname: "All Network",
  //         nwid: "65",
  //         sensorid: "000001",
  //         gatewayid: "000001",
  //         type: "control",
  //       },
  //     });
  //   }
  //   if (to.name == "Resetpassword") {
  //     next();
  //   } else if (to.name == "Request") {
  //     next();
  //   } else if (
  //     to.name == "kubotafarmSolar" ||
  //     to.name == "kubotafarmRice" ||
  //     to.name == "kubotafarmOverview" ||
  //     to.name == "kubotafarmPlant3" ||
  //     to.name == "kubotafarmPlant4" ||
  //     to.name == "kubotafarmPlant5" ||
  //     to.name == "kubotafarmPlant6" ||
  //     to.name == "kubotafarmPlant7" ||
  //     to.name == "kubotafarmPlant8"
  //   ) {
  //     Vue.prototype.$session.set("guestKubotauser", "guest_kubota");
  //     next();
  //   } else if (to.path.includes("PublicAjinomoto")) {
  //     Vue.prototype.$session.set("guestAjinomotouser", "guest_Ajinomoto");
  //     next();
  //   } else if (
  //     to.name !== "Login" &&
  //     to.name !== "Register" &&
  //     to.name !== "Login2" &&
  //     to.name !== "loginnew" &&
  //     !Vue.prototype.$session.get("token")
  //   ) {
  //     // console.log(to)
  //     Vue.prototype.$session.set("path", to);
  //     next({ name: "Login" });
  //   } else {
  //     next();
  //   }

  //   new router
  const userData = Vue.prototype.$session.get("username");
  const accessToken = Vue.prototype.$session.get("accessToken");

  const isLoggedIn = userData && Vue.prototype.$session.get("accessToken");
  // console.log('route',userData,'isLoggedIn', isLoggedIn,accessToken);

  if (to.meta.resource != "Public") {
    if (isLoggedIn) {
      return next();
    }
    return next("/");
  }
  return next();
});
//
export default router;
